import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import clone from 'clone-deep';
import { Select, DualMultiselect } from 'spicecomponents';
import { getListOfCountrySpecificBreaks } from 'utils/AYDAUtils';

import { updateClusterList } from '../../../containers/App/actions';

class BreakMultiselectContainerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBreak: this.props.arrayItems.length > 0 ? Object.keys(this.props.arrayItems[0])[0] : '',
      breakGroup: props.arrayItems,
    };
  }
  onChange(val) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(this.props.index, val);
    }
  }
  onGroupChange(value) {
    if (value !== 'None') {
      this.setState({ selectedBreak: value });
    } else {
      this.setState({ selectedBreak: '' });
    }
  }
  onAnswerChange(val) {
    const values = val.map((v) => v.value);
    let breakGroup = this.state.breakGroup.filter((v) => Object.keys(v)[0] !== this.state.selectedBreak);

    let cdfAnswers = values;
    if (cdfAnswers.includes('*'))cdfAnswers = ['*'];
    breakGroup = breakGroup.concat(values.map((v) => ({ [this.state.selectedBreak]: v })));

    const breakList = this.props.cdf.BreakList ? clone(this.props.cdf.BreakList) : [];
    breakList[this.props.index] = breakGroup;

    this.setState({
      breakGroup,
    });

    this.props.updateBreakList(this.props.index, breakGroup);
    this.onChange(breakGroup);
  }
  getGroupOptions() {
    const cl = this.props.controlList;

    const countrySpecificBreaks = getListOfCountrySpecificBreaks(cl);
    const availableBreaks = cl.Options[this.getSurvey()].filter((breakGroup) => {
      const breakGroupName = Object.keys(breakGroup)[0];
      // If break name does not appear in list of specific breaks, return true
      if (countrySpecificBreaks[breakGroupName] === undefined) {
        return true;
      // else, if we have not got a country or if the countries specified includes our country, return true
      }
      return !this.props.cdf.Country || countrySpecificBreaks[breakGroupName].includes(this.props.cdf.Country);
    });

    return [{ value: 'None' }].concat(availableBreaks.map((v) => (
      { value: Object.keys(v)[0], text: Object.values(v)[0].BreakGroupLabel }
    )));
  }
  getAnswerOptions(disableOptions) {
    if (this.state.selectedBreak) {
      const cl = this.props.controlList;
      const breakGroup = cl.Options[this.getSurvey()].filter((b) => this.state.selectedBreak === Object.keys(b)[0])[0];
      const answers = Object.values(breakGroup)[0].BreakAnswers;
      return [{ value: '*' }].concat(answers.map((a) => {
        const text = Object.keys(a)[0];
        return {
          value: text,
          disabled: disableOptions,
        };
      }));
    }
    return [];
  }
  getAnswerValue() {
    if (this.state.selectedBreak) {
      const selectedForThisBreak = this.state.breakGroup.filter((b) => Object.keys(b)[0] === this.state.selectedBreak);
      if (selectedForThisBreak.map((v) => Object.values(v)[0]).includes('*')) {
        return ['*'];
      }
      return selectedForThisBreak.map((s) => Object.values(s)[0]);
    }
    return [];
  }
  getSurvey() {
    const survey = this.props.cdf.Survey;
    if (!survey || survey.length > 1) {
      return 'AllSurveys';
    }
    return survey[0];
  }
  render() {
    const answerValue = this.getAnswerValue();
    const multiselectContainerComponent = (
      <div>
        <p>Select at least one customer sub-group. To select all choose &quot;&lowast;&quot;.</p>
        <DualMultiselect options={this.getAnswerOptions(answerValue[0] === '*')} value={answerValue} onChange={(e) => this.onAnswerChange(e)} />
      </div>
    );
    return (
      <div>
        <Select options={this.getGroupOptions()} value={this.state.selectedBreak} onChange={(e) => this.onGroupChange(e)} />
        {this.state.selectedBreak.length > 0 && multiselectContainerComponent}
      </div>
    );
  }
}

BreakMultiselectContainerComponent.propTypes = {
  arrayItems: PropTypes.array,
  index: PropTypes.number,
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  updateBreakList: PropTypes.func,
  onChange: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({});

export function mapDispatchToProps(dispatch) {
  return {
    updateBreakList: (index, value) => {
      dispatch(updateClusterList(index, value, 'BreakList'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(BreakMultiselectContainerComponent);



// WEBPACK FOOTER //
// ./app/components/FormControls/BreakList/MultiselectContainer.js